/* gs-footer.js — mobile accordion behaviour for the footer columns.
 *
 * Grüns drives these with a single `is-open` class on the <li>; the panel's
 * open/closed heights are plain CSS (max-height 0 <-> 500px) so the animation
 * is declarative and there is no height math to get wrong. We do the same.
 *
 * The panel animates max-height AND padding-bottom together. Padding has to be
 * in the transition: a border-box element cannot render shorter than its own
 * padding, so animating height alone stalls at the panel's padding and then
 * jumps — the same trap that bit pdp-accordion.js.
 *
 * Above 992px the columns are always open and the toggle is pointer-events:none,
 * so this script deliberately does nothing there beyond keeping aria-expanded
 * honest for assistive tech.
 */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 992px)');

  function columns(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.gsf-col'));
  }

  function setOpen(col, open) {
    col.classList.toggle('is-open', open);
    var toggle = col.querySelector('.gsf-col__toggle');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function syncToViewport(root) {
    // On desktop every panel is open and its state is not user-controlled.
    columns(root).forEach(function (col) {
      var toggle = col.querySelector('.gsf-col__toggle');
      if (!toggle) return;
      if (DESKTOP.matches) {
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('tabindex', '-1');
      } else {
        toggle.removeAttribute('tabindex');
        toggle.setAttribute(
          'aria-expanded',
          col.classList.contains('is-open') ? 'true' : 'false'
        );
      }
    });
  }

  function init(root) {
    if (!root || root.dataset.gsfBound === 'true') return;
    root.dataset.gsfBound = 'true';

    columns(root).forEach(function (col) {
      var toggle = col.querySelector('.gsf-col__toggle');
      if (!toggle) return;

      toggle.addEventListener('click', function (event) {
        if (DESKTOP.matches) return;
        event.preventDefault();
        setOpen(col, !col.classList.contains('is-open'));
      });
    });

    syncToViewport(root);

    var onChange = function () {
      syncToViewport(root);
    };
    if (typeof DESKTOP.addEventListener === 'function') {
      DESKTOP.addEventListener('change', onChange);
    } else if (typeof DESKTOP.addListener === 'function') {
      DESKTOP.addListener(onChange); // Safari < 14
    }
  }

  function boot() {
    Array.prototype.slice
      .call(document.querySelectorAll('.gsf-root'))
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The theme editor re-renders the section on every setting change.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.gsf-root');
    if (root) init(root);
  });
})();
